<template>
  <!-- <pre v-if="responseData"> testData={{ queryParams }}</pre> -->
  <AdminBackground v-if="responseData">
    <div class="image-wrapper">
      <img
        src="@/assets/header/SENARAI PBT.png"
        alt="SENARAI PBT"
        class="pbt-image"
      >
      <!-- Center the line under the image -->
      <div class="line-under-image" />
    </div>


    <div class="content-wrapper">
      <div class="input-row">
        <div class="input-item">
          <AppAutocomplete
            v-model="selectedsState"
            label="Negeri"
            :items="states"
            placeholder="Pilih Negeri"
            chips
            multiple
            closable-chips
            class="app-date-picker"
            @update:model-value="handleStateChange"
          />
        </div>
      </div>

      
      <h2>JUMLAH DAN STATUS PBT DI SELURUH MALAYSIA</h2>
      <div class="content">
        <div
          :style="{ background: items[0].color }"
          class="box full-width"
        >
          <p>{{ items[0].title }}</p>
          <span class="count">{{ items[0].location }}</span>
        </div>

     
        <div
          v-for="item in items.slice(1)"
          :key="item.title"
          :style="{ background: item.color }"
          class="box"
        >
          <p>{{ item.title }}</p>
          <span class="count">{{ item.location }}</span>
        </div>
      </div>
    </div>

    
    <div class="content-wrapper">
      <h2>PBT DI SELURUH MALAYSIA</h2>
      <MapNew />
    </div> 
   
    <PrimaryModule />
    <InspektoratMenu />
  </AdminBackground>
</template>

<script setup>
import InspektoratMenu from '@/components/menu-items/section-menu/inspektorat-menu.vue'
import { useHttpService } from "@/httpService"
import { computed, ref } from 'vue'

//added by abdullah 
definePage({
  alias: '/pages/pages/inspektorat/i-tegur',
  meta: {
    layout: 'blank',
    public: true,
  },
})

const years = ref([])
const states = ref(["Semua Negeri"])
const pbt = ref([])
const councils = ref([])
const selectedYear = ref(2025)
const selectedsState = ref('Semua Negeri')
const selectedPbt = ref('Semua PBT')

const { httpGet } = useHttpService()

const pbtData = ref({ 
  jumlah: 0,
  jumlahBandaraya: 0,
  jumlahDaerah: 0,
  jumlahModifiedPbt: 0,
  jumlahPerbandaran: 0,
})

const items = computed(() => [
  { title: 'Jumlah Keseluruhan PBT Seluruh Malaysia', location: pbtData.value.jumlah, color: 'linear-gradient(0deg, #029708 0%, #013103 100%)' },
  { title: 'Bandaraya', location: pbtData.value.jumlahBandaraya, color: 'linear-gradient(0deg, #AE0101 0%, #480101 100%)' },
  { title: 'Perbandaran', location: pbtData.value.jumlahPerbandaran, color: 'linear-gradient(0deg, #25008F 0%, #0B0029 100%)' },
  { title: 'Daerah', location: pbtData.value.jumlahDaerah, color: 'linear-gradient(0deg, #7800A3 0%, #2D003D 100%)' },
  { title: 'Modified PBT', location: pbtData.value.jumlahModifiedPbt, color: 'linear-gradient(0deg, #7800A3 0%, #2D003D 100%)' },
])


// const items = computed(() => [
//   { title: 'Jumlah Keseluruhan PBT Seluruh Malaysia', location: 156, color: 'linear-gradient(0deg, #029708 0%, #013103 100%)' },
//   { title: 'Bandaraya', location: 20, color: 'linear-gradient(0deg, #AE0101 0%, #480101 100%)' },
//   { title: 'Perbandaran', location: 41, color: 'linear-gradient(0deg, #25008F 0%, #0B0029 100%)' },  
//   { title: 'Daerah', location: 91, color: 'linear-gradient(0deg, #7800A3 0%, #2D003D 100%)' },
//   { title: 'Modified PBT', location: 4, color: 'linear-gradient(0deg, #7800A3 0%, #2D003D 100%)' },
// ])


const responseData = ref(null)


async function loadDataFromApi(year = selectedYear.value, state = selectedsState.value, pbtValue = selectedPbt.value) {
  try {

   
    const plainStates = toRaw(state)

 
    let queryParams = `year=${year}`
   

    // Check if states are "Semua Negeri" and skip appending states[] if true
    if (!plainStates.includes("Semua Negeri")) {
      // Append each state to the query string with the desired 'states[]' format
      if (Array.isArray(plainStates)) {
        plainStates.forEach(state => {
          const stateName = typeof state === "string" ? state : state.name || state.value
          if (stateName) {
            queryParams += `&states[]=${encodeURIComponent(stateName)}`
          }
        })
      } else {
        queryParams += `&states[]=${encodeURIComponent(plainStates)}`
      }
    }

    // Append councils[] if pbtValue is selected
    if (Array.isArray(pbtValue) && !pbtValue.includes('Semua PBT')) {
      // Append each PBT in the array to the query parameters
      pbtValue.forEach(pbt => {
        queryParams += `&councils[]=${encodeURIComponent(pbt)}`
      })
    }

    // Construct the URL with the query parameters
    const url = `inspektorat/senarai-pbt?${queryParams}`

    const response = await httpGet(url)

    console.log('Request URL:', url)
    console.log('API Response:', response)



    years.value = response.years


    states.value = ["Semua Negeri"]
    response.states.forEach(state => {
      if (state && state !== "Modified Pbt") {
        states.value.push(state)
      }
    })

    councils.value = response.councils

    responseData.value = response
    var data = responseData.value?.data?.data

  

    pbtData.value = {
      jumlah: data.jumlah ?? 0,
      jumlahBandaraya: data.jumlah_bandaraya ?? 0,
      jumlahDaerah: data.jumlah_daerah ?? 0,
      jumlahModifiedPbt: data.jumlah_modified_pbt ?? 0,
      jumlahPerbandaran: data.jumlah_perbandaran ?? 0,
    }

  } catch (err) {
    console.error("loadDataFromApi failed:", err)
  }
}

function handleStateChange() {
  pbt.value = []

  // Ensure selectedsState is an array
  if (!Array.isArray(selectedsState.value)) {
    selectedsState.value = selectedsState.value ? [selectedsState.value] : []
  }

  // Remove "Semua Negeri" if other states are selected
  if (selectedsState.value.includes("Semua Negeri") && selectedsState.value.length > 1) {
    selectedsState.value = selectedsState.value.filter(state => state !== "Semua Negeri")
  }

  // If no states are selected, reset to "Semua Negeri"
  if (selectedsState.value.length === 0) {
    selectedsState.value = ["Semua Negeri"]
  }

  if (selectedsState.value.includes("Semua Negeri")) {
    // Add all councils from all states
    Object.keys(councils.value).forEach(state => {
      if (state) {
        pbt.value.push(...councils.value[state].map(council => council.value))
      }
    })
  } else {
    // Only add councils for the selected states
    selectedsState.value.forEach(state => {
      if (councils.value[state]) {
        console.log('Adding councils for state:', state, councils[state])
        pbt.value.push(...councils.value[state].map(council => council.value))
      } else {
        console.warn(`No councils found for state: ${state}`)
      }
    })
  }

  console.log('Filtered PBT:', pbt.value)
}


onMounted(() => {
  loadDataFromApi()
  
})


watch(councils, newValue => {
  if (newValue) handleStateChange()
}, { immediate: true })


watch([selectedYear, selectedsState, selectedPbt], () => {
  loadDataFromApi(selectedYear.value, selectedsState.value, selectedPbt.value)
}, { immediate: true })
</script>


<style scoped>
.image-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-block-end: 20px;
}

.pbt-image {
  block-size: auto;
  max-inline-size: 70%; /* Adjusted size */
}

.line-under-image {
  border-radius: 5px;
  background-color: white;
  block-size: 5px;
  inline-size: 70%; /* Match width to the image size */
  margin-block-start: 10px;
}

.content-wrapper {
  display: flex;
  flex-direction: column;
  padding: 20px;
  border-radius: 20px; /* Rounded corners */
  background-color: rgba(255, 255, 255, 65%); /* Background for content */
  box-shadow: 0 4px 15px rgba(0, 0, 0, 20%); /* Shadow for depth */
  inline-size: 100%;
  margin-block: 20px;
  margin-inline: 0;
  max-inline-size: 1200px;
}


/* Flexbox container for the input fields */
.input-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

/* Styles for each input field */
.input-item {
  flex: 1;
  margin-right: 15px;
}

/* Remove margin for the last item */
.input-item:last-child {
  margin-right: 0;
}



h2 {
  color: rgb(21, 0, 105);
  font-size: 1.5rem;
  font-weight: bold;
  inline-size: 100%;
  margin-block: 40px 10px;
  text-align: left;
}

.title-main {
  color: darkblue;
  font-size: 2rem;
  font-weight: bold;
  margin-block-end: 20;
  text-align: center;
}

.filter-wrapper {
  display: flex;
  justify-content: flex-end; /* Ensure it's flex-end to move content to the right */
  gap: 10px;
  inline-size: 100%; /* Make sure it spans the full width */
  margin-block-end: 20px;
}

.filter-box {
  display: flex;
  align-items: center;
  justify-content: flex-end; /* This keeps the label and select aligned to the right */
  gap: 10px;
}

.filter-box label {
  color: black;
  font-weight: bold;
  margin-block-end: 0; /* Removed bottom margin */
}

.filter-box select {
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  background: white;
  inline-size: auto;
}

.content {
  display: grid;
  gap: 20px;
  grid-template-columns: repeat(4, 1fr);
  inline-size: 100%;
}

.full-width {
  grid-column: span 4; /* Make this box span across all columns */
}

.box {
  position: relative;
  display: flex;
  overflow: hidden;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  block-size: 100px;
  inline-size: 100%;
  transition: transform 0.3s;
}

.box:hover {
  transform: translateY(-5px);
}

.box p,
.box .count {
  color: white;
  font-weight: bold;
  text-align: center;
}

.box p {
  font-size: 1rem;
}

.box .count {
  font-size: 2rem;
}

.my-5 {
  margin-block: 1.25rem;
  margin-inline: 0;
}

@media (max-width: 1024px) {
  .content-wrapper {
    max-inline-size: 1000px;
  }

  .pbt-image {
    max-inline-size: 70%;
  }

  .content {
    grid-template-columns: repeat(2, 1fr); /* Change to two columns */
  }

  .box {
    block-size: 90px; /* Slightly smaller box size */
  }

  h2 {
    font-size: 1.3rem;
  }
}

/* Tablet view (max-width: 768px) */
@media (max-width: 768px) {
  .content-wrapper {
    padding: 15px;
  }

  .pbt-image {
    max-inline-size: 70%;
  }

  .input-row {
    flex-direction: column;
    gap: 10px;
  }

  .content {
    grid-template-columns: 1fr; /* Single column layout */
  }

  h2 {
    font-size: 1.2rem;
    text-align: left;
  }

  .box {
    block-size: 80px;
  }
}

/* Mobile view (max-width: 480px) */
@media (max-width: 480px) {
  .content-wrapper {
    padding: 10px;
  }

  .pbt-image {
    max-inline-size: 70%;
  }

  h2 {
    font-size: 1rem;
    text-align: left;
  }

  .content {
    grid-template-columns: 1fr;
    gap: 10px;
  }

  .box {
    block-size: 70px;
  }

  .box p {
    font-size: 0.9rem;
  }

  .box .count {
    font-size: 1.5rem;
  }
}
</style>
